import React from "react";
import { Col, Row } from "reactstrap";
import {
  formatDateForDisplay,
  formatPhoneNumber,
} from "../Utils/UtilityFunctions";

const ViewReservation = ({
  storedData,
  values,
  globalOffers,
  updatedStations,
}) => {
  const station = updatedStations?.find(
    (station) => station?.value === values?.station?.value
  );
  const renderDoubleColumnRow = (
    leftLabel,
    leftValue,
    rightLabel,
    rightValue,
    noBorder = false,
    noValue = false,
    isSingleRow = false
  ) => {
    const formatValue = (label, value) => {
      return value ? value : "N/A";
    };

    return (
      <div className={`d-flex mb-3 pb-2 ${noBorder ? "" : "border-bottom"}`}>
        <div className="w-50 pe-3">
          {leftLabel && <label className="fw-semibold">{leftLabel}</label>}
          {!noValue && (
            <p className="detail-value mb-0">
              {formatValue(leftLabel, leftValue)}
            </p>
          )}
        </div>
        {!isSingleRow && (
          <div className="w-50 ps-3">
            {rightLabel && <label className="fw-semibold">{rightLabel}</label>}
            {!noValue && (
              <p className="detail-value mb-0">
                {formatValue(rightLabel, rightValue)}
              </p>
            )}
          </div>
        )}
      </div>
    );
  };
  return (
    <div className="customer-profile-container py-2">
      <Row className="justify-content-center">
        <Col lg={10}>
          <div className="rounded-1 px-3 py-3 my-2 bg-white">
            <div className="profile-details-section">
              <p className="fs-5 fw-semibold mb-3 pb-2 border-bottom">
                Customer Details
              </p>
              {renderDoubleColumnRow(
                "Customer Name",
                `${storedData?.customerInfo?.firstName} ${storedData?.customerInfo?.lastName}`,
                "Contact",
                formatPhoneNumber(
                  `${storedData?.customerInfo?.dialCode}${storedData?.customerInfo?.mobile}`
                )
              )}
              {renderDoubleColumnRow(
                "Email",
                storedData?.customerInfo?.email,
                "Address",
                `${storedData?.customerInfo?.addressLine1} ${storedData?.customerInfo?.addressLine2}`
              )}
              {renderDoubleColumnRow(
                "ID Token Type",
                values?.idTokenType?.value,
                "",
                null,
                true,
                false,
                true
              )}
              {/* {
                <>
                  <p className="fs-5 fw-semibold mt-4 mb-3 pb-2 border-bottom">
                    Offer Details
                  </p>
                  {renderDoubleColumnRow(
                    "Resource Name",
                    globalOffers[0]?.usageRatePlan[0]?.balanceImpact[0]
                      ?.resourceName,
                    "UOM",
                    globalOffers[0]?.usageRatePlan[0]?.balanceImpact[0]?.uomName
                  )}
                  {renderDoubleColumnRow(
                    "Per Unit",
                    globalOffers[0]?.usageRatePlan[0]?.balanceImpact[0]
                      ?.rateTier[0]?.perUnitRate,
                    "Flat Rate",
                    globalOffers[0]?.usageRatePlan[0]?.balanceImpact[0]
                      ?.rateTier[0]?.flatRate
                  )}
                  {renderDoubleColumnRow(
                    "Station",
                    station?.label || values?.station?.value,
                    "",
                    null,
                    true,
                    false,
                    true
                  )}
                </>
              } */}
              {
                <>
                  <p className="fs-5 fw-semibold mt-4 mb-3 pb-2 border-bottom">
                    Reservation Details
                  </p>
                  {renderDoubleColumnRow(
                    "Station",
                    station?.label || values?.station?.value,
                    "Start Date & Time",
                    formatDateForDisplay(values?.startTime, "hh:mm A")
                  )}
                  {renderDoubleColumnRow(
                    "End Date & Time",
                    formatDateForDisplay(values?.endTime, "hh:mm A"),
                    "EVSE",
                    "",

                    true,
                    false,
                    false
                  )}
                  {renderDoubleColumnRow(
                    "Connector Type",
                    "",
                    "",
                    null,
                    true,
                    false,
                    true
                  )}
                </>
              }
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ViewReservation;
